module.exports = "/_next/static/images/video_id_7127445808269790510-fc6eb7744d3f1a0bc8aaff877f199189.jpg";